<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ContractPage',

};
</script>

<style>

</style>
